import React, { FC } from 'react'
import { observer } from 'mobx-react'
import { classNames, format } from '@dt/fe-utils'
import { modalLayer } from '@utils'
import { payPlanMobx } from '@mobxStore'
import CustomTipModal from '../CustomTipModal'

interface IProps {
  option: ICustomTipOption;
  onSelected?: () => void;
}

const CustomTipItem: FC<IProps> = ({ option, onSelected }) => {
  const selected = payPlanMobx.selectedTipOption?.type === 'custom'

  const onClick = async () => {
    const amount = await modalLayer(CustomTipModal, null, 'customTipModal') as number
    payPlanMobx.selectTipOption({
      type: 'custom',
      amount,
    })
    onSelected && onSelected()
  }

  return (
    <li className={classNames('select-tip-item', { selected })} data-cypid='customTipItem' onClick={onClick}>
      <span className='amount'>{i18n.t('pay.customTip')}</span>
      <span className='amount'>{selected && format.toPrice(payPlanMobx.selectedTipOption?.amount)}</span>
      <i className='iconfont icon-chevron-right' />
    </li>
  )
}

export default observer(CustomTipItem)
